import React from 'react';
import { isRenu } from '../utils/ui.utils';

const regionList = (loc, species) => {
  switch (loc) {
    case "Hungary":
      if (species.includes('White Goose')) {
        return "Eastern Southern South-Eastern";
      } else if (species.includes('White Duck')) {
        return "Eastern Southern";
      } else if (species.includes('Grey Goose')) {
        return "Southern";
      } else {
        return "Eastern Southern South-Eastern";
      }
    case "Europe":
      if (species.includes('White Goose')) {
        return "HUNGARY";
      } else if (species.includes('White Duck')) {
        return "HUNGARY";
      } else if (species.includes('Grey Goose')) {
        return "HUNGARY";
      } else {
        return "HUNGARY ROMANIA";
      }
    default:
      return "ORIGIN REGIONS";
  }
};

export const DetailOriginText = ({ down_type, origin, t, originExceptionFlag }) => {
  let originActiveTitle;
  let originActiveValue;

  if (isRenu(down_type)) {
    originActiveTitle = "";
    originActiveValue = t("species.renuBlend");
  } else if (originExceptionFlag) {
    // Priority override for the special 0404 branch (and others)
    originActiveTitle = t("origin.hungary");
    originActiveValue = "Hungary"; // Consistent with AppLegacy forcing "Hungary" display
  } else {
    originActiveTitle = regionList(origin, down_type);
    originActiveValue = origin;
  }

  return (
    <>
      <p className="spec-title">{originActiveTitle}</p>
      <p className="spec-value">{originActiveValue}</p>
    </>
  );
};